import React from 'react'

/**
 * Simple icon component
 */
class Icon extends React.Component {
  static propTypes = {
    name: React.PropTypes.string.isRequired,
    size: React.PropTypes.string,
    fixedWidth: React.PropTypes.bool,
    border: React.PropTypes.bool,
    spin: React.PropTypes.bool,
    pulse: React.PropTypes.bool,
    flip: React.PropTypes.string,
    rotate: React.PropTypes.number
  }

  render() {
    let cls = `fa ${this.props.name}`

    if (this.props.size) cls += ` fa-${this.props.size}`
    if (this.props.fixedWidth) cls += ' fa-fw'
    if (this.props.border) cls += ' fa-border'
    if (this.props.flip) cls += ` fa-flip-${this.props.flip}`
    if (this.props.rotate) cls += ` fa-rotate-${this.props.rotate}`
    if (this.props.spin) cls += ' fa-spin'
    if (this.props.pulse) cls += ' fa-pulse'

    return (
      <i className={cls} {...this.props} />
    )
  }
}

export default Icon



// WEBPACK FOOTER //
// ./modules/shared/components/icon.js